import { IVessel } from '../contracts/vessel.contract';
import AxiosService from './axios.service';
import ConfigService from './config.service';

const getAll = async (): Promise<IVessel[]> => {
    const res = await AxiosService.getInstance.get(`${ConfigService.appConfig.baseApiUrl}/Vessel/GetByClient`);
    return res.data;
};

const VesselService = {
    getAll
};

export default VesselService;
